module.exports = __webpack_public_path__ + "img/plus.705a940e.svg";